"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.breakpoints = exports.css = exports.clsx = exports.cx = exports.keyframes = exports.GlobalStyles = void 0;
var tslib_1 = require("tslib");
var css_1 = require("@emotion/css");
var react_1 = require("@emotion/react");
var styled_1 = tslib_1.__importDefault(require("@emotion/styled"));
var breakpoints_1 = require("@eduzz/houston-tokens/variables/breakpoints");
/**
 * @deprecated Import from `@emotion/react`
 */
exports.GlobalStyles = react_1.Global;
/**
 * @deprecated Import from `@emotion/react`
 */
exports.keyframes = react_1.keyframes;
/**
 * @deprecated Import from `@emotion/css`
 */
exports.cx = css_1.cx;
/**
 * @deprecated Import cx from `@emotion/css`
 */
exports.clsx = css_1.cx;
/**
 * @deprecated Import from `@emotion/react`
 */
exports.css = react_1.css;
/**
 * @deprecated
 */
exports.breakpoints = breakpoints_1.breakpoinstUtils;
/**
 * @deprecated Import from `@emotion/styled`
 */
var styled = styled_1.default;
/**
 * @deprecated Import from `@emotion/styled`
 */
exports.default = styled;
